"use strict";

exports.__esModule = true;
var _PredefinedCommentsPanel = require("./PredefinedCommentsPanel");
Object.keys(_PredefinedCommentsPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsPanel[key]) return;
  exports[key] = _PredefinedCommentsPanel[key];
});